import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import TextInput from '../../../../molecules/Input';
import actionTypes from '../../constants/actionTypes';
import '../fieldRenderer.scss';
var getClassNames = function getClassNames(props) {
  if (props.error) return "error ".concat(props.fieldClassName);
  return props.fieldClassName;
};
var getWrapperDivProps = function getWrapperDivProps(props) {
  var fieldLevelDataAttributes = props.fieldLevelDataAttributes;
  return fieldLevelDataAttributes;
};
var TextInputField = /*#__PURE__*/function (_PureComponent) {
  _inherits(TextInputField, _PureComponent);
  var _super = _createSuper(TextInputField);
  function TextInputField() {
    var _this;
    _classCallCheck(this, TextInputField);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      var _this$props = _this.props,
        id = _this$props.id,
        onAction = _this$props.onAction,
        triggerChangeOnBlur = _this$props.triggerChangeOnBlur,
        additional = _this$props.additional;
      onAction({
        type: actionTypes.ON_FIELD_CHANGE,
        payload: {
          id: id,
          value: triggerChangeOnBlur ? event : event.target.value,
          additional: additional
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (event) {
      var _this$props2 = _this.props,
        id = _this$props2.id,
        onAction = _this$props2.onAction;
      onAction({
        type: actionTypes.ON_FIELD_BLUR,
        payload: {
          id: id,
          event: event
        }
      });
    });
    return _this;
  }
  _createClass(TextInputField, [{
    key: "render",
    value: function render() {
      var props = this.props;
      return /*#__PURE__*/React.createElement(TextInput, _extends({
        wrapperDivProps: getWrapperDivProps(props),
        containerClassName: getClassNames(props),
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        defaultValue: props.value
      }, props));
    }
  }]);
  return TextInputField;
}(PureComponent);
TextInputField.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.number]),
  onAction: PropTypes.func.isRequired,
  triggerChangeOnBlur: PropTypes.bool
};
TextInputField.defaultProps = {
  value: '',
  triggerChangeOnBlur: false
};
export default TextInputField;